import { Directive, ElementRef, Input } from '@angular/core';
import { AriaElement } from '../aria-element.directive';

@Directive({
  selector: '[appAriaSelect]',
  standalone: false
})
export class AriaSelectDirective extends AriaElement<HTMLIonSelectElement> {
  constructor(protected el: ElementRef<HTMLIonSelectElement>) {
    super(el);

    this.adaptHidden = false;
  }

  @Input() set appAriaSelect(label: string) {
    this.currentLabel = label;
    this.untillDone.do();
  }

  findElements(): HTMLElement[] {
    return [
      this.el.nativeElement,
      this.el.nativeElement.shadowRoot.querySelector('label')
    ];
  }
}
